"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = onActiveQualityChanged;
var _TheoQualityHelper = require("../TheoQualityHelper");
function onActiveQualityChanged(event) {
  var currentRendition = this._currentRendition || this.rawPlayer && this.rawPlayer.videoTracks && this.rawPlayer.videoTracks.length && this.rawPlayer.videoTracks.item(0).activeQuality;
  var newRendition = event.quality;
  var bitrateEvent = {
    prevBitrate: currentRendition.bandwidth,
    prevHeight: currentRendition.height,
    prevWidth: currentRendition.width,
    newBitrate: newRendition.bandwidth,
    newHeight: newRendition.height,
    newWidth: newRendition.width,
    prevDuration: Number((performance.now() - this.logger.times.DurationBitrate).toFixed(2))
  };
  var initialRendition = (0, _TheoQualityHelper.initialRenditionForCurrentQuality)(this.rawPlayer, this._qualities.normalised, newRendition);
  if (initialRendition && initialRendition !== this._desiredInitialRendition) {
    this._desiredInitialRendition = initialRendition;
  }
  if (bitrateEvent.prevBitrate && bitrateEvent.prevBitrate !== bitrateEvent.newBitrate) {
    this.logger.logQuality('BitrateChanged', bitrateEvent);
  }
  this.logger.times.DurationBitrate = performance.now();
  this._currentRendition = newRendition;
  this.emit('activequalitychanged', event);
  // backwards compatability w/ THEO1
  this.emit('qualitychanged', event);
}